import React, { createContext, useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [session, setSession] = useState(null); // Add session state

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      const { data: { session: currentSession }, error } = await supabase.auth.getSession();

      if (error) {
        console.error('Error fetching session:', error);
        setUser(null);
        setIsAuthenticated(false);
        setSession(null);
      } else if (currentSession) {
        setUser(currentSession.user);
        setIsAuthenticated(true);
        setSession(currentSession); // Store the session
      } else {
        setUser(null);
        setIsAuthenticated(false);
        setSession(null);
      }

      setLoading(false);
    };

    fetchUser();

    // Subscribe to auth state changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, newSession) => {
      if (event === 'SIGNED_IN') {
        setUser(newSession?.user || null);
        setIsAuthenticated(true);
        setSession(newSession); // Update session on sign in
      } else if (event === 'SIGNED_OUT') {
        setUser(null);
        setIsAuthenticated(false);
        setSession(null); // Clear session on sign out
      } else if (event === 'TOKEN_REFRESHED') {
        setSession(newSession); // Update session when token refreshes
      }
    });

    // Clean up the subscription on component unmount
    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, isAuthenticated, session }}>
      {children}
    </AuthContext.Provider>
  );
};